import React from 'react';
import { Card, Alert } from 'react-bootstrap';

const BulkUploadResults = ({ result, type }) => {
  if (!result) return null;

  let summary;
  if (type === 'upload') {
    summary = (
      <ul>
        <li>Total records: {result.total}</li>
        <li>Successfully imported: {result.successful}</li>
        <li>Errors: {result.errors?.length || 0}</li>
      </ul>
    );
  } else if (type === 'update') {
    summary = (
      <ul>
        <li>Updated: {result.updatedCount || 0}</li>
        <li>Not Found: {result.notFound?.length || 0}</li>
      </ul>
    );
  } else if (type === 'notAttended') {
    summary = (
      <ul>
        <li>Total records: {result.total}</li>
        <li>Updated: {result.updated}</li>
        <li>Flagged as left: {result.flagged}</li>
        <li>Not Found: {result.notFound?.length || 0}</li>
        <li>Errors: {result.errors?.length || 0}</li>
      </ul>
    );
  }

  return (
    <Card className="mb-4">
      <Card.Header>
        <h5>Results</h5>
      </Card.Header>
      <Card.Body>
        <Alert variant="info">{summary}</Alert>
      </Card.Body>
    </Card>
  );
};

export default BulkUploadResults;